var _path, _path2, _path3, _path4, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgFileTypesPdf = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 36,
  height: 45,
  fill: "none"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "url(#file-types-pdf_svg__a)",
  d: "M32.25 1.467H3.75C1.679 1.467 0 3.127 0 5.175V40.78c0 2.048 1.679 3.709 3.75 3.709h28.5c2.071 0 3.75-1.66 3.75-3.709V5.175c0-2.048-1.679-3.708-3.75-3.708Z"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  fill: "#000",
  fillOpacity: 0.2,
  d: "M32.25 1.467H3.75C1.679 1.467 0 3.127 0 5.175V40.78c0 2.048 1.679 3.709 3.75 3.709h28.5c2.071 0 3.75-1.66 3.75-3.709V5.175c0-2.048-1.679-3.708-3.75-3.708Z"
})), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
  fill: "url(#file-types-pdf_svg__b)",
  d: "M32.25 0H3.75C1.679 0 0 1.66 0 3.709v35.604c0 2.049 1.679 3.71 3.75 3.71h28.5c2.071 0 3.75-1.661 3.75-3.71V3.71C36 1.66 34.321 0 32.25 0Z"
})), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M24.758 16.2c.469.468.742 1.093.742 1.758v10.82c0 1.406-1.133 2.5-2.5 2.5H13a2.468 2.468 0 0 1-2.5-2.5v-15c0-1.367 1.094-2.5 2.5-2.5h5.82c.664 0 1.29.273 1.758.742l4.18 4.18Zm-5.508-3.555v4.258c0 .351.273.625.625.625h4.258a.982.982 0 0 0-.274-.469l-4.14-4.14a.983.983 0 0 0-.469-.274Zm5 16.133v-10h-4.375A1.851 1.851 0 0 1 18 16.903v-4.375h-5c-.703 0-1.25.586-1.25 1.25v15c0 .703.547 1.25 1.25 1.25h10c.664 0 1.25-.547 1.25-1.25Zm-10-6.875c0-.313.273-.625.625-.625h6.25c.313 0 .625.312.625.625a.642.642 0 0 1-.625.625h-6.25a.617.617 0 0 1-.625-.625Zm6.875 1.875c.313 0 .625.312.625.625a.642.642 0 0 1-.625.625h-6.25a.617.617 0 0 1-.625-.625c0-.313.273-.625.625-.625h6.25Zm0 2.5c.313 0 .625.312.625.625a.642.642 0 0 1-.625.625h-6.25a.617.617 0 0 1-.625-.625c0-.313.273-.625.625-.625h6.25Z"
})), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
  id: "file-types-pdf_svg__a",
  x1: 0,
  x2: 33.244,
  y1: 26.93,
  y2: 17.317,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#36A7B7"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.971,
  stopColor: "#0061A7"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "file-types-pdf_svg__b",
  x1: 0,
  x2: 33.244,
  y1: 25.464,
  y2: 15.85,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#36A7B7"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.971,
  stopColor: "#0061A7"
})))));
export { SvgFileTypesPdf as ReactComponent };
export default "data:image/svg+xml;base64,ZXhwb3J0IGRlZmF1bHQgX193ZWJwYWNrX3B1YmxpY19wYXRoX18gKyAiNzM2ZjUwYzE2YTg0ZjAyYmQzNGM4MWJlODVhYzBjZWMuc3ZnIjs=";